
Greenmile.Geofence = Greenmile.Geofence || {};

Greenmile.Geofence.SideBarFilters = function (sidebar, content) {

    this.appendFilters = function () {
        if (sidebar) {
            sidebar.setContentOnMenu(content);
        }
    };

    this.addTitle = function (father) {
        var geofenceTitle = document.createElement('div');
        geofenceTitle.className = 'i18nResource';
        geofenceTitle.id = 'title';
        geofenceTitle.innerHTML = Monet.I18n.getResourcesByKey('Geofence.title');
        father.appendChild(geofenceTitle);
    };

    this.addDescriptionFilter = function (father) {
        var label = document.createElement('label');
        label.innerHTML = Monet.I18n.getResourcesByKey('geofence.description');

        var text = document.createElement('input');
        text.id = 'geofenceTextDescription';

        father.appendChild(label);
        father.appendChild(text);
    };

    this.addOrganizations = function (father) {
        const organizationField = new Monet.UI.Fields.PowerLookup();
        organizationField.setLookUpEntity('Organization');
        organizationField.setDisplayKey('description');
        father.appendChild(organizationField.render());
    };

};
